import React from 'react';
import LocaleString from 'app/ui/config/LocaleString';
import './style/ErrorPageTemplate.css';
import { DEFAULT, LOGIN } from '../../../api/redux-route/routes';
import MascotEnabled from '../../config/MascotEnabled';
import ErrorPageLink from './ErrorPageLink';
import SimpleHeaderFrame from './SimpleHeaderFrame';
import { isLoggedInToBridge } from '../../../api/redux-bridge/session/selectors';
import { connect } from 'react-redux';
import { isJigsawOnly } from '../../../api/redux-watson/watson-config-selectors';
import { MIDDLE } from '../../fonts/FontProvider';
import BasePage from '../shared/BasePage';

function ErrorPageTemplate({
  bo: Bo,
  messageIds,
  hasLibraryLink,
  loggedIn,
  disableLogoLink,
  jigsawOnly,
}) {
  return (
    <BasePage
      fontKey={MIDDLE}
      titleId="common.pageTitles.error"
      overflow="auto"
      minWidth="370px"
      minHeight="650px"
    >
      <SimpleHeaderFrame disableLogoLink={disableLogoLink}>
        <div className="ErrorPageTemplate">
          <MascotEnabled>
            <div className="ErrorPageTemplate__Bo">
              <Bo />
            </div>
          </MascotEnabled>
          {messageIds.map(id => {
            return (
              <p className="ErrorPageTemplate__Message" key={id}>
                <LocaleString id={id} />
              </p>
            );
          })}
          {hasLibraryLink &&
            !jigsawOnly && (
              <div className="ErrorPageTemplate__LibraryLink">
                <ErrorPageLink to={loggedIn ? DEFAULT : LOGIN}>
                  <LocaleString
                    id={
                      loggedIn
                        ? 'common.errorPages.backToLibrary'
                        : 'common.errorPages.backToSignIn'
                    }
                  />
                </ErrorPageLink>
              </div>
            )}
        </div>
      </SimpleHeaderFrame>
    </BasePage>
  );
}

const mapStateToProps = state => ({
  loggedIn: isLoggedInToBridge(state),
  jigsawOnly: isJigsawOnly(state),
});

export default connect(mapStateToProps)(ErrorPageTemplate);



// WEBPACK FOOTER //
// ./src/app/ui/pages/error/ErrorPageTemplate.js